import { useMutation, useQueryClient } from '@tanstack/react-query'

import { useOsApi } from '@/frontend/hooks/api/use-os-api'

/** Deletes a vitals record. */
export function useDeleteVitals(options?: { patientId?: string; consultationId?: string }) {
  const api = useOsApi()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (id: string) => {
      const response = await api.delete('/vitals/:id', { params: { id } })
      if (!response.success) throw new Error(response.error.message)
    },
    onSuccess: () => {
      if (options?.patientId) {
        queryClient.invalidateQueries({ queryKey: ['patient-vitals', options.patientId] })
        queryClient.invalidateQueries({ queryKey: ['patient-timeline', options.patientId] })
      }
      if (options?.consultationId) {
        queryClient.invalidateQueries({ queryKey: ['consultation', options.consultationId] })
      }
    },
  })
}
